/*
Akhila 12/26/2022 3075154998 Added Add Rule Popup
Akhila 12/28/2022 3075154998 Added Add  Action popUp and Added Fields
Sohel 12/29/2022 3075154998 Added props
Suresh Peddavoora 12/30/2022 3075154998 Added classname for Enter value textfield
Akhila 12/30/2022 3075154998 Added Field Validation
Suresh Peddavoora 01/06/2022 3075154998 Added classname for Font size Enhancements
Dilip 09/01/2023 3075154998 added check syntax functionality
Dilip 12/01/2023 3075154998 removed condition for check syntax functionality
Sai Maheshwar 01/13/2023 2699704333 fixed action edit and delete
Sohel 01/12/2023 2698964415 Pre Processor payload Changes
Prakash 01/16/2023 2698964415 Fixed Responsiveness.
Akhila 01/18/2023 2698964415 bug fixed page break issue
Akhila 01/20/2023 2698964415 success Validation issue on reset bug fixed
Sohel 01/23/2023 3075154998 Added code based on Condition
Sohel 01/23/2023 3075154998 check syntax payload changes
Sohel 01/24/2023 2698964415 removed space between Temp repo
Ashraf 04/02/2023 2698964415 Added bypass and bypass record actions
Sohel 02/21/2023 2698964415 Audit Field List Changes
Sohel 03/10/2023 2701335619 Added Error Record in Action
Sohel 03/14/2023 2698964415 Added Error Reason in Payload
Sohel 03/17/2023 2698964415 Fixed Action Dropdown data issue
Guru Prasad 03/29/2023 2698964415 Fixed Fields alignments
Sohel 03/29/2023 2698964415 audit fields constant changes
Sohel 04/04/2023 2698964415 By pass Record Changes
Ravi 04/04/2023 2698964415 Fixed dropdown issue of fields.
Akhila 04/05/2023 2698964415 Added change status and change client fields for action
Guru Prasad 04/05/2023 2698964415 Fixed Ui for change status and change client fields for action
Akhila 04/06/2023 2698964415 Added condition to status 9000 cancel code field
Akhila 04/06/2023 2701335619 Added dropdowndata on field and validation
Sohel 04/07/2023 2698964415 By pass Changes
Sohel 04/08/2023 2698964415 Change Status and Change client Payload nad Validation Changes
Sohel 04/08/2023 2698964415 Payload Changes
Sohel 04/08/2023 2698964415 remove wait Days validation
Prakash 12-04-23 2698964415 remove margin top  in export-template-record.
Sohel 04/19/2023 2698964415 Added Error Record in Exports
Sohel 04/19/2023 2698964415 Added Error Record in Exports
Sohel 04/26/2023 2698964415 Remove NO Change CheckBox
Akhila 04/28/2023 2698964415 Added change status dropdown value for export in action
Sohel 04/28/2023 2698964415 Added Error Record dropdown value for export in action
Sohel 06/16/2023 2698964415 Changed Fields API in Action and Condition
Sohel 10/10/2023 2700912712 Fixed Repository Name Space Issue
Sohel 10/16/2023 2700912712 changed Field Dropdown value.
Sohel 10/06/2023 2700912712 fixed cancel code pre population issue.
*/
import {
  Button,
  FormHelperText,
  makeStyles,
  TextField,
  FormControl,
  Tooltip,
  InputAdornment,
} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import {Form, Formik} from 'formik';
import React, {useEffect, useRef, useState} from 'react';
import {useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {fetchFunctionDetailsById} from '../../../../../../redux/reducers/BRE/AddRuleGroup';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import PageLoader from '../../../../../../components/PageLoader';
import './styles.scss';
import ActionAddRuleSelectFields from './ActionAddRuleSelectFields';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import * as Yup from 'yup';
import {httpPost} from '../../../../../../util/Rest';
import {
  fetchErrorRecordCode,
  fetchExportErrorRecordData,
  fetchStatusFieldsData,
  resetExportErrorRecordData,
} from '../../../../../../redux/reducers/DataManagerRecord';
import {CLOSURE_CODE, DISPOSITION_CODE} from '../../../../../../constants/Lookup';
import {fetchDispositionCodes} from '../../../../../../redux/reducers/EventTactics/EventTactics';
import {NumberFormatterPostiveNegavtive} from '../../../../../../components/UserDefinedForm/AppTextInputComponents';
import {fetchClientNumberDropDownData} from '../../../../../../redux/reducers/clientMangement/Organizaation';
import {getObject} from '../../../../../../util/GetDropdownObject';
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: '600',
  },
  taskParameters: {
    border: '1px dashed',
    padding: '25px 10px 0px 10px',
    position: 'relative',
    marginBottom: '15px',
    borderRadius: '4px',
  },
}));
const exportType = [{value: 'Data Export'}, {value: 'Header'}, {value: 'Footer'}];
const ActionAddRule = ({
  setActionFormData,
  actionformData,
  isActionEditMode,
  setIsActionEditMode,
  actionOldRuleCode,
  actionRowData,
  setOpen,
  handleClose,
  conditionalProps,
  managerRecordGroup,
}) => {
  const classes1 = useStyles();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const componentClasses = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const {
    allFunctions = [],
    functionDetails,
    operatorsDropdownData,
    dmActions,
  } = useSelector(({addRuleGroup}) => addRuleGroup);
  const {recordCode, errorRecordDropdownData, exportErrorRecordData,dataManagerRecordId} = useSelector(
    ({dataManagerRecord}) => dataManagerRecord,
  );
  const errorRecordDropdownValues = [...errorRecordDropdownData];
  errorRecordDropdownValues?.unshift('Default');
  const exportErrorData =
    exportErrorRecordData?.length > 0 ? exportErrorRecordData?.map((el) => el?.recordCode) : [];
  const {groupCode, basicInfoData: recordGroupData,dmRecordGroupId} = useSelector(
    ({dataManagerRecordGroup}) => dataManagerRecordGroup,
  );

  const {name, value, handleValueChange, exportManagerRecord} = conditionalProps;

  const {
    selectedFields,
    basicInfoData,
    statusFieldsData,
  } = useSelector(({dataManagerRecord}) => dataManagerRecord);

  const seedOnlyOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const selectedProcessorFields =
  selectedFields?.length > 0 ?
    selectedFields?.map((el) => {
      if (el?.fieldType === 'Audit Field') {
        return {
          ...el,
          repositoryName: 'aud.' + el.repositoryName,
        };
      } else {
        return {
          ...el,
        };
      }
    }) :
    [];
  const data = [...value.actions];
  const condition = data?.filter(
    (el) =>
      el?.selectField?.repositoryName + '.' + el?.selectField?.fieldName ===
      'temporary_repo.bypassrec',
  );
  const conditionBypass = data?.filter(
    (el) =>
      el?.selectField?.repositoryName + '.' + el?.selectField?.fieldName === 'temporary_repo.bypass',
  );
  if (!condition?.length) {
    selectedProcessorFields?.unshift({
      repositoryName: 'temporary_repo',
      fieldName: 'bypassrec',
      dataType: 'Text',
    });
  } else if (condition?.length > 0) {
    selectedProcessorFields?.filter(
      (el) =>
        el?.selectField?.repositoryName + '.' + el?.selectField?.fieldName !==
        'temporary_repo.bypassrec',
    );
  }
  if (!conditionBypass?.length) {
    selectedProcessorFields?.unshift({
      repositoryName: 'temporary_repo',
      fieldName: 'bypass',
      dataType: 'Text',
    });
  } else if (conditionBypass?.length > 0) {
    selectedProcessorFields?.filter(
      (el) =>
        el?.selectField?.repositoryName + '.' + el?.selectField?.fieldName !==
        'temporary_repo.bypass',
    );
  }
  const dispatch = useDispatch();
  const parameterRef = useRef();
  const {dispositionDropDown} = useSelector(
    ({addEventTactic}) => addEventTactic,
  );
  const {clientNumberAPIdata} = useSelector(({organization}) => organization);

  const actionData = ['New Account Import']?.includes(
    basicInfoData?.recordType ?
      basicInfoData?.recordType :
      recordGroupData?.groupType ?
        recordGroupData?.groupType :
        '',
  ) ?
    dmActions?.filter((i) => !['Change Status', 'Change Client']?.includes(i?.value)) :
    ['New Account Import', 'Data Update']?.includes(
      basicInfoData?.recordType ?
        basicInfoData?.recordType :
        recordGroupData?.groupType ?
          recordGroupData?.groupType :
          '',
    ) ?
      dmActions :
      exportManagerRecord ?
        dmActions?.filter(
          (i) => !['Change Client']?.includes(i?.value), // "Error Record",
        ) :
        [];
  const [actionOptions, setActionOptions] = useState(actionData);

  useEffect(() => {
    const arr = [];
    value &&
      value?.actions?.length > 0 &&
      value?.actions?.map((i) => {
        arr.push(i?.action);
      });
    const newOptions = actionData?.filter(
      (i) =>
        i?.value === 'Set' ||
        !arr.includes(i?.value) ||
        (isActionEditMode && actionRowData?.action === i?.value && arr.includes(i?.value)),
    );
    setActionOptions(newOptions);
  }, [value]);
  const getObjects = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.value === option || item === option || item.key === option) {
          label = item;
        }
      });
    return label;
  };
  const getFieldsObjects = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.repositoryName + '.' + item?.repositoryFieldCode === option) {
          label = item;
        }
      });
    return label;
  };
  const initialVal = {
    action: null,
    function: null,
    parameter: '',
    operators: null,
    errorRecord:
      isActionEditMode &&
      actionRowData &&
      actionRowData.parameter &&
      actionRowData.action === 'Error Record' &&
      exportManagerRecord ?
        getObjects(actionRowData.parameter, exportErrorData) :
        isActionEditMode &&
          actionRowData &&
          actionRowData.parameter &&
          actionRowData.action === 'Error Record' &&
          !exportManagerRecord ?
          getObjects(actionRowData.parameter, errorRecordDropdownValues) :
          exportManagerRecord ?
            '' :
            getObjects('Default', errorRecordDropdownValues),
    bypassParameter: {value: 'Yes', valueCode: 'Y'},
    errorReason:
      isActionEditMode && actionRowData && actionRowData.errorReason ?
        actionRowData?.errorReason :
        '',
    disposition:
      isActionEditMode &&
      actionRowData?.parameter?.dispositionType === 'Status' &&
      actionRowData?.parameter?.disposition ?
        getObject(actionRowData?.parameter?.disposition, DISPOSITION_CODE, dispositionDropDown) :
        '',
    daysToWait:
      isActionEditMode && actionRowData && actionRowData?.parameter?.waitDate ?
        actionRowData?.parameter?.waitDate :
        '',
    clientCode:
      isActionEditMode && actionRowData && actionRowData?.parameter ?
        getObjects(actionRowData?.parameter, clientNumberAPIdata) :
        '',
    cancelCode:isActionEditMode && actionRowData && actionRowData?.parameter?.cancelCode ?
      getObject(actionRowData?.parameter?.cancelCode, CLOSURE_CODE, dispositionDropDown) : '',   
    Untie:
      isActionEditMode && actionRowData && actionRowData?.parameter?.untie ?
        getObjects(actionRowData?.parameter?.untie, seedOnlyOptions) :
        '',
    selectFieldStatus:
      isActionEditMode &&
      actionRowData?.parameter?.dispositionType === 'Field' &&
      actionRowData?.parameter?.disposition ?
        getFieldsObjects(actionRowData?.parameter?.disposition, statusFieldsData) :
        '',
    recordType:
      isActionEditMode && actionRowData.action === 'Error Record' && exportManagerRecord ?
        getObjects(actionRowData.selectField, exportType) :
        '',
  };
  const validation = Yup.object().shape({
    action: Yup.mixed().required('Action is required'),
    selectField: Yup.mixed().test('selectField', 'Field is required', function(value, context) {
      const {parent} = context;
      if (parent?.action?.value === 'Set' && !value?.fieldName) {
        return false;
      } else {
        return true;
      }
    }),
    parameter:
      isActionEditMode && actionRowData && actionRowData.action === 'Change Status' ?
        null :
        Yup.string().test('parameter', 'Value is required', function(value, context) {
          const {parent} = context;
          if (parent?.action?.value === 'Set' && !value) {
            return false;
          } else {
            return true;
          }
        }),

    Untie: Yup.mixed().test('Untie', 'Untie is required', (value, ctx) => {
      if (ctx.parent?.action?.value === 'Change Status' && !value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    cancelCode: Yup.mixed().test('cancelCode', 'Cancel Code is required', (value, ctx) => {
      if (
        ctx.parent?.action?.value === 'Change Status' &&
        !value?.valueCode &&
        ctx.parent?.disposition?.valueCode === '9000'
      ) {
        return false;
      } else {
        return true;
      }
    }),
    clientCode: Yup.mixed().test('clientNumber', 'Client Number is required', (value, ctx) => {
      if (ctx.parent?.action?.value === 'Change Client' && !value) {
        return false;
      } else {
        return true;
      }
    }),
    recordType: Yup.mixed().test('recordType', 'Record Type is required', (value, ctx) => {
      if (ctx.parent?.action?.value === 'Error Record' && !value && exportManagerRecord) {
        return false;
      } else {
        return true;
      }
    }),
    errorRecord: Yup.mixed().test('errorRecord', 'Error Record is required', (value, ctx) => {
      if (ctx.parent?.action?.value === 'Error Record' && !value && exportManagerRecord) {
        return false;
      } else {
        return true;
      }
    }),
    disposition: Yup.mixed().test(
      'disposition',
      'Status or Field are required',
      (val, formValues) => {
        if (formValues?.parent?.action?.value === 'Change Status') {
          const bothValPresent = [
            formValues?.parent?.disposition,
            formValues?.parent?.selectFieldStatus,
          ].filter(Boolean);
          const anyoneOneIsPresent =
            formValues?.parent?.disposition || formValues?.parent?.selectFieldStatus;
          if (anyoneOneIsPresent && bothValPresent.length === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      },
    ),
  });

  const [initialValues, setInitialValues] = useState(initialVal);
  useEffect(() => {
    if (isActionEditMode && actionRowData.action === 'Error Record' && exportManagerRecord) {
      const type = actionRowData.selectField?.replace(' ', '_');
      dispatch(fetchExportErrorRecordData(type));
    }
  }, [isActionEditMode, actionRowData.selectField]);
  useEffect(() => {
    if (dmRecordGroupId || dataManagerRecordId ) {
      const payload = managerRecordGroup ? dmRecordGroupId : dataManagerRecordId
      dispatch(fetchStatusFieldsData(payload));
    }
  }, [dataManagerRecordId,dmRecordGroupId]);
  useEffect(() => {
    if (allFunctions && allFunctions.length > 0) {
      const initialValues = {
        // seqNo: 1,
        action:
          isActionEditMode && actionRowData && actionRowData.action ?
            getObjects(actionRowData.action, actionOptions) :
            '',
        selectField:
          isActionEditMode && actionRowData && actionRowData.selectField ?
            actionRowData.selectField :
            '',

        parameter:
          isActionEditMode && actionRowData && actionRowData.parameter ?
            actionRowData.parameter :
            '',
      };
      setInitialValues((prev) => ({...prev, ...initialValues, function: allFunctions[0]}));
      dispatch(fetchFunctionDetailsById(allFunctions[0].dataCalculationFunctionId));
    }
  }, [allFunctions, actionOptions]);
  useEffect(() => {
    if (operatorsDropdownData && operatorsDropdownData.length > 0) {
      setInitialValues((prev) => ({...prev, operators: operatorsDropdownData[0]}));
    }
  }, [operatorsDropdownData]);
  useEffect(() => {
    if (
      exportErrorData &&
      exportErrorData.length > 0 &&
      isActionEditMode &&
      actionRowData &&
      actionRowData.parameter &&
      actionRowData.action === 'Error Record'
    ) {
      setInitialValues((prev) => ({
        ...prev,
        errorRecord:
          isActionEditMode &&
          actionRowData &&
          actionRowData.parameter &&
          actionRowData.action === 'Error Record' &&
          exportManagerRecord ?
            getObjects(actionRowData.parameter, exportErrorData) :
            '',
      }));
    }
  }, [exportErrorRecordData]);
  useEffect(() => {
    if (!exportManagerRecord) {
      if (recordCode && !managerRecordGroup) {
        dispatch(fetchErrorRecordCode(recordCode));
      } else if (groupCode && managerRecordGroup) {
        dispatch(fetchErrorRecordCode(groupCode));
      }
    }
  }, []);
  // useEffect(() => {
  //   if (isActionEditMode && exportManagerRecord) {
  //     setInitialValues((prev) => ({
  //       ...prev,
  //       errorRecord:
  //         isActionEditMode &&
  //         actionRowData &&
  //         actionRowData.parameter &&
  //         actionRowData.action === "Error Record"
  //           ? getObjects(actionRowData.parameter, exportErrorData)
  //           : "",
  //     }));
  //   }
  // }, [exportErrorData]);

  const handleCheckSyntax = (values) => {
    if (values?.selectField?.dataType && values?.parameter?.trim()) {
      setIsLoading(true);
      const payload = {
        code: managerRecordGroup ? groupCode : recordCode,
        dataType: values?.selectField.dataType,
        ruleExpression: values?.parameter ? values?.parameter?.trim() : '',
        fileType: exportManagerRecord ? 'Export' : 'Import',
        moduleType: managerRecordGroup ? 'Record Group' : 'Record',
      };
      httpPost(`rules/validate/dmrule`, payload)
        .then((response) => {
          console.log(response, 'res');
          if (response?.data?.status === 400) {
            setIsLoading(false);
            setErrorMessage(response?.data?.message);
            setSuccessMessage(null);
          } else if (response?.status === 200) {
            setIsLoading(false);
            setSuccessMessage(response?.response);
            // handleSubmission({...values, formulaExpression: response?.response});
            setErrorMessage(null);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          setErrorMessage(error);
        });
    }
  };
  const getOptions = (typeCode) => {
    let label = [];

    label =
      dispositionDropDown && dispositionDropDown[typeCode] ? dispositionDropDown[typeCode] : [];

    return label;
  };
  useEffect(() => {
    dispatch(fetchDispositionCodes());
    dispatch(fetchClientNumberDropDownData());
  }, []);
  const handleSubmit = (values) => {
    const data = {...values};
    const copyData = [...value.actions];
    const statusParameters = {
      disposition: values?.disposition?.valueCode ?
        values?.disposition?.valueCode :
        values?.selectFieldStatus?.repositoryName ?
          values?.selectFieldStatus?.repositoryName +
          '.' +
          values?.selectFieldStatus?.repositoryFieldCode :
          '',
      cancelCode: values?.cancelCode?.valueCode ? values?.cancelCode?.valueCode : '',
      waitDate: values?.daysToWait ? values?.daysToWait : '',
      untie: values?.Untie?.key ? values?.Untie?.key : '',
      dispositionType: values?.disposition?.valueCode ?
        'Status' :
        values?.selectFieldStatus?.repositoryName ?
          'Field' :
          '',
    };
    if (!isActionEditMode) {
      copyData.push({
        ...data,
        selectField:
          exportManagerRecord && values?.action?.value === 'Error Record' ?
            values?.recordType?.value :
            values.selectField,
        action: values.action.value,
        // seqNo: values.seqNo,
        parameter:
          values?.action?.value === 'Error Record' ?
            values?.errorRecord :
            values?.action?.value === 'Change Status' ?
              statusParameters :
              values?.action?.value === 'Change Client' ?
                values?.clientCode :
                values.parameter?.trim(),
        tableData: {checked: true},
        formulaExpression: successMessage,
        errorReason: values?.errorReason || '',
      });
      handleValueChange(`${name}.actions`, copyData);
      // setActionFormData(copyData);
      handleClose();
    } else {
      const updatedData = copyData.map((each, i) => {
        if (i === actionRowData.index && values.action.value !== 'Set') {
          return {
            ...each,
            selectField:
              exportManagerRecord && values.action.value === 'Error Record' ?
                values?.recordType?.value :
                '',
            action: values.action.value,
            ruleCode: data.ruleCode,
            parameter:
              values.action.value === 'Error Record' ?
                values?.errorRecord :
                values?.action?.value === 'Change Status' ?
                  statusParameters :
                  values?.action?.value === 'Change Client' ?
                    values?.clientCode :
                    '',
            formulaExpression: '',
            errorReason: values?.errorReason || '',
          };
        } else if (i === actionRowData.index) {
          return {
            ...each,
            ruleCode: data.ruleCode,
            selectField: values.selectField,
            action: values.action.value,
            parameter: values?.parameter?.trim(),
            formulaExpression: successMessage,
          };
        } else {
          return {...each};
        }
      });
      handleValueChange(`${name}.actions`, updatedData);
      // setActionFormData(updatedData);
      setOpen(false);
      setIsActionEditMode(false);
    }
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validation}
      enableReinitialize
      onSubmit={(values) => handleSubmit(values)}
    >
      {(props) => {
        const {values, handleChange, setFieldValue, resetForm, touched, errors, handleBlur} =
          props;
        let showValidations = null;
        let currentErrMsg = '';
        if (errors.disposition && values?.action?.value === 'Change Status') {
          currentErrMsg = errors.disposition;
          showValidations = touched.disposition || touched.selectFieldStatus;
        }
        return (
          <>
            <div className="px-2 mb-3">
              {showValidations && currentErrMsg && (
                <Alert className="mb-2" severity="error">
                  {currentErrMsg}
                </Alert>
              )}
            </div>
            <Form noValidate>
              <div
                style={{
                  padding: '0rem 1rem',
                }}
              >
                <div className="form-row global-field-textfields new-standard-textfields">
                  <div className="col-md-3 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="action"
                      id="action"
                      size="small"
                      value={values.action}
                      // options={actionOptions}
                      options={actionOptions}
                      // options={actionDropDown2}
                      getOptionLabel={(option) => {
                        return option ? option?.value : '';
                      }}
                      onChange={(e, value) => {
                        setFieldValue('action', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            className={` ${classes.labelName}`}
                            required
                            error={touched.action && errors.action}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{ shrink: true }}
                            label="Action"
                            // onBlur={handleBlur}
                            placeholder="Select Action"
                          />
                        </div>
                      )}
                    />
                    <FormHelperText variant="outlined">
                      {touched?.action && errors?.action ? errors.action : ''}
                    </FormHelperText>
                  </div>
                  {values.action?.value === 'Error Record' ? (
                    <>
                      {exportManagerRecord && (
                        <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="recordType"
                            id="recordType"
                            size="small"
                            value={values.recordType}
                            options={exportType}
                            getOptionLabel={(option) => {
                              return option?.value ? option?.value : '';
                            }}
                            autoHighlight
                            onChange={(e, value) => {
                              dispatch(resetExportErrorRecordData());
                              setFieldValue('errorRecord', '');
                              setFieldValue('recordType', value);
                              if (value?.value) {
                                const type = value?.value?.replace(' ', '_');
                                dispatch(fetchExportErrorRecordData(type));
                              }
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  className={` ${classes.labelName}`}
                                  {...params}
                                  variant="outlined"
                                  margin="dense"
                                  name="recordType"
                                  error={Boolean(touched.recordType && errors.recordType)}
                                  label={`Record Type`}
                                  required
                                  onBlur={handleBlur}
                                  placeholder={`Select Record Type`}
                                />
                                <FormHelperText style={{color: 'red'}} variant="outlined">
                                  {touched.recordType && errors.recordType}
                                </FormHelperText>
                              </div>
                            )}
                          />
                        </div>
                      )}
                      <div className="col-md-3 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="errorRecord"
                          id="errorRecord"
                          size="small"
                          value={values.errorRecord}
                          options={
                            exportManagerRecord ? exportErrorData : errorRecordDropdownValues || []
                          }
                          getOptionLabel={(option) => {
                            return option ? option : '';
                          }}
                          onChange={(e, value) => {
                            setFieldValue('errorRecord', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={` ${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                required
                                error={Boolean(touched.errorRecord && errors.errorRecord)}
                                // InputLabelProps={{ shrink: true }}
                                label="Error Record"
                                placeholder="Select Error Record"
                              />
                            </div>
                          )}
                        />
                        <FormHelperText style={{color: 'red'}} variant="outlined">
                          {touched.errorRecord && errors.errorRecord}
                        </FormHelperText>
                      </div>
                      <div className="col-md-4 form-group">
                        <TextField
                          className={` ${classes.labelName} text-description-fields`}
                          margin="dense"
                          variant="outlined"
                          placeholder={'Enter Error Reason'}
                          label="Error Reason"
                          multiline
                          minRows={2}
                          maxRows={2}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          name="errorReason"
                          value={values?.errorReason}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          fullWidth
                        />
                      </div>
                    </>
                  ) : null}
                  {values.action?.value === 'Bypass' || values.action?.value === 'Bypass Record' ? (
                    <div className="col-md-3 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="bypassParameter"
                        id="bypassParameter"
                        size="small"
                        value={values.bypassParameter}
                        disabled
                        options={[{value: 'Yes', valueCode: 'Y'}]}
                        getOptionLabel={(option) => {
                          return option ? option?.value + ' ' + '-' + ' ' + option?.valueCode : '';
                        }}
                        onChange={(e, value) => {
                          setFieldValue('bypassParameter', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={` ${classes.labelName}`}
                              required
                              error={touched.bypassParameter && errors.bypassParameter}
                              variant="outlined"
                              margin="dense"
                              InputLabelProps={{shrink: true}}
                              label="Value"
                              // onBlur={handleBlur}
                              placeholder="Select Value"
                            />
                          </div>
                        )}
                      />
                    </div>
                  ) : null}

                  {values.action?.value === 'Set' ? (
                    <div className="col-md-12">
                      <div className="row">
                        <ActionAddRuleSelectFields
                          label={'Functions'}
                          options={allFunctions}
                          value={values.function}
                          name="function"
                          handleChange={(_, value) => {
                            setFieldValue('function', value);
                            if (value?.dataCalculationFunctionId) {
                              dispatch(fetchFunctionDetailsById(value?.dataCalculationFunctionId));
                            }
                          }}
                          handleInsert={() => {
                            const selectedFunc = functionDetails?.syntax;
                            const cursorPosition = parameterRef.current?.selectionStart;
                            if (values.parameter) {
                              setFieldValue(
                                'parameter',
                                values?.parameter?.slice(0, cursorPosition) +
                                  selectedFunc +
                                  values?.parameter?.slice(cursorPosition),
                              );
                              parameterRef.current?.focus();
                            } else {
                              setFieldValue('parameter', selectedFunc);
                            }
                          }}
                          optionLable={(option) => option.functionName}
                        />
                        <ActionAddRuleSelectFields
                          label={'Fields'}
                          options={
                            selectedProcessorFields?.length > 0 ? selectedProcessorFields : []
                          }
                          renderOption={(props, item) => {
                            return (
                              <li {...props} key={item.key}>
                                {props.key}
                              </li>
                            );
                          }}
                          optionLable={(option) => {
                            return option ?
                              (
                                option?.repositoryName +
                                  '.' +
                                  option?.fieldName
                              ) :
                              '';
                          }}
                          handleChange={(_, value) => {
                            setFieldValue('fields', value);
                          }}
                          handleInsert={() => {
                            const selectedFunc = values?.fields?.repositoryName ?
                              `${values?.fields?.repositoryName
                              }.${values?.fields?.fieldName}` :
                              '';
                            const cursorPosition = parameterRef.current?.selectionStart;
                            if (values?.parameter) {
                              setFieldValue(
                                'parameter',
                                values?.parameter?.slice(0, cursorPosition) +
                                  selectedFunc +
                                  values?.parameter?.slice(cursorPosition),
                              );
                              parameterRef.current?.focus();
                            } else {
                              setFieldValue('parameter', selectedFunc);
                            }
                          }}
                        />
                        <ActionAddRuleSelectFields
                          label="Operators"
                          options={operatorsDropdownData || []}
                          optionLable={(option) =>
                            `${option?.valueCode || ''} ${option?.value || ''}`
                          }
                          handleChange={(_, value) => {
                            setFieldValue('operators', value);
                          }}
                          value={values?.operators}
                          handleInsert={() => {
                            const selectedFunc = values?.operators?.valueCode ?
                              `${values?.operators?.valueCode}` :
                              '';
                            const cursorPosition = parameterRef.current?.selectionStart;
                            if (values?.parameter) {
                              setFieldValue(
                                'parameter',
                                values?.parameter?.slice(0, cursorPosition) +
                                  selectedFunc +
                                  values?.paramete?.slice(cursorPosition),
                              );
                              parameterRef.current?.focus();
                            } else {
                              setFieldValue('parameter', selectedFunc);
                            }
                          }}
                        />
                      </div>

                      {functionDetails && 'functionName' in functionDetails && (
                        <Accordion className="accordion-styling function-usage-accordion">
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography className={classes1.heading}>
                              Function Usage Help
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div className="function-usage">
                              <p>
                                <span>Function:</span>
                                {functionDetails?.functionName}
                              </p>
                              <p>
                                <span>Description:</span> {functionDetails?.description}
                              </p>
                              <p>
                                <span>Syntax:</span> {functionDetails?.syntax}
                              </p>
                              <p>
                                <span>Example:</span> {functionDetails?.example}
                              </p>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      )}
                      <div className="row mt-3 global-field-textfields new-standard-textfields">
                        <div className="col-md-4">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="selectField"
                            id="selectField"
                            size="small"
                            value={values?.selectField}
                            options={
                              selectedProcessorFields?.length > 0 ? selectedProcessorFields : []
                            }
                            getOptionLabel={(option) => {
                              return option && option?.fieldName ?
                                (
                                  option?.repositoryName +
                                    '.' +
                                    option?.fieldName
                                ) :
                                '';
                            }}
                            onChange={(e, value) => {
                              setFieldValue('selectField', value);
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  className={` ${classes.labelName}`}
                                  variant="outlined"
                                  margin="dense"
                                  error={Boolean(touched?.selectField && errors?.selectField)}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  required
                                  label="Field"
                                  placeholder="Select Field"
                                />
                              </div>
                            )}
                          />
                          <FormHelperText variant="outlined">
                            {touched?.selectField && errors?.selectField ? errors.selectField : ''}
                          </FormHelperText>
                        </div>
                        {values?.selectField?.dataType && (
                          <div className="col-md-4">
                            <TextField
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter the value with Data Type ${values?.selectField?.dataType}`}
                              className={` ${classes.labelName} text-description-fields`}
                              label="Value"
                              multiline
                              minRows={2}
                              maxRows={2}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name="parameter"
                              required
                              value={values?.parameter}
                              error={Boolean(touched?.parameter && errors?.parameter)}
                              onChange={(e) => {
                                setErrorMessage(null);
                                setSuccessMessage(null);
                                handleChange(e);
                              }}
                              inputRef={parameterRef}
                              fullWidth
                            />
                            {errorMessage && <div className="error-text">{errorMessage}</div>}
                            {successMessage && (
                              <div className="success-text">Expression is valid</div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  {values?.selectField?.dataType && values?.action?.value === 'Set' && (
                    <div>
                      <Button
                        variant="outlined"
                        type="button"
                        className={`search-btn ${classes.buttonRoot} mt-2 `}
                        onClick={() => handleCheckSyntax(values)}
                      >
                        Check syntax
                      </Button>
                    </div>
                  )}
                  {values.action?.value === 'Change Status' && (
                    <>
                      <div className={`col-md-12 ${componentClasses.taskParameters} mx-2`}>
                        <Typography variant="h4" className={classes.legend}>
                          Status
                        </Typography>
                        <div className="form-row align-items-center">
                          <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                            <FormControl margin="dense" variant="outlined" fullWidth>
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                name={'disposition'}
                                id={'disposition'}
                                size="small"
                                value={values?.disposition}
                                onChange={(e, value) => {
                                  setFieldValue('disposition', value);
                                }}
                                options={getOptions(DISPOSITION_CODE)}
                                getOptionLabel={(option) => {
                                  return option && option.value ?
                                    option.valueCode === null ?
                                      option.value :
                                      option.valueCode + ' - ' + option.value :
                                    '';
                                }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      className={` ${classes.labelName}`}
                                      {...params}
                                      variant="outlined"
                                      margin="dense"
                                      onBlur={handleBlur}
                                      label={'Status'}
                                      placeholder={`Select Status`}
                                    />
                                  </div>
                                )}
                              />
                            </FormControl>
                          </div>

                          <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                            <GuiAutoComplete
                              classes={{
                                option: classes.option,
                              }}
                              name="selectFieldStatus"
                              id="selectFieldStatus"
                              size="small"
                              value={values?.selectFieldStatus}
                              options={statusFieldsData || []}
                              getOptionLabel={(option) => {
                                return option && option?.repositoryFieldCode ?
                                  (
                                    option?.repositoryName +
                                      '.' +
                                      option?.repositoryFieldCode
                                  ) :
                                  '';
                              }}
                              onChange={(e, value) => {
                                setFieldValue('selectFieldStatus', value);
                              }}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    className={` ${classes.labelName}`}
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    label="Field"
                                    placeholder="Select Field"
                                  />
                                </div>
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      {values?.disposition?.valueCode === '9000' && (
                        <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name={'cancelCode'}
                            id={'cancelCode'}
                            size="small"
                            value={values?.cancelCode ? values?.cancelCode : ''}
                            onChange={(e, value) => {
                              setFieldValue('cancelCode', value);
                            }}
                            //   disabled={
                            //     !(
                            //       values?.disposition?.valueCode === "9000" ||
                            //       values?.disposition?.valueCode === "9999"
                            //       )
                            //     }
                            options={getOptions(CLOSURE_CODE)}
                            getOptionLabel={(option) => {
                              return option && option.value ?
                                option.valueCode === null ?
                                  option.value :
                                  option.valueCode + ' - ' + option.value :
                                '';
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  className={` ${classes.labelName}`}
                                  {...params}
                                  variant="outlined"
                                  margin="dense"
                                  label={'Cancel Code'}
                                  required
                                  error={touched.cancelCode && errors.cancelCode}
                                  placeholder={`Select Cancel Code`}
                                />
                              </div>
                            )}
                          />
                          <FormHelperText>
                            {touched?.cancelCode && errors && errors.cancelCode}
                          </FormHelperText>
                        </div>
                      )}
                      <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                        <GuiAutoComplete
                          classes={`${{
                            popper: classes.popper,
                            option: classes.option,
                          }}`}
                          name="Untie"
                          id="Untie"
                          size="small"
                          options={seedOnlyOptions}
                          required
                          value={values.Untie}
                          getOptionLabel={(option) => {
                            return option?.value ? option.value : '';
                          }}
                          onChange={(e, value) => {
                            setFieldValue('Untie', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Untie"
                                placeholder="Select Untie"
                                required
                                error={touched.Untie && errors.Untie}
                              />
                            </div>
                          )}
                        />
                        <FormHelperText>
                          {touched.Untie && errors.Untie && errors.Untie}
                        </FormHelperText>
                      </div>
                      <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                        <TextField
                          className={` ${classes.labelName}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Wait Days`}
                          label={'Wait Days'}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">Today +</InputAdornment>
                            ),
                            inputComponent: NumberFormatterPostiveNegavtive,
                          }}
                          name={'daysToWait'}
                          value={values?.daysToWait}
                          onChange={(e) => {
                            setFieldValue('daysToWait', e.target.value);
                          }}
                          fullWidth
                          onBlur={handleBlur}
                          touched={touched.daysToWait}
                        />
                      </div>
                    </>
                  )}
                  <div className="col-sm-8 col-md-6 col-lg- 4 col-xl-4 form-group">
                    {values.action?.value === 'Change Client' && (
                      <div>
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="clientCode"
                          id="clientCode"
                          size="small"
                          value={values.clientCode}
                          freeSolo
                          options={clientNumberAPIdata || []}
                          getOptionLabel={(option) => {
                            return option ? option : '';
                          }}
                          required
                          onChange={(e, value) => {
                            setFieldValue('clientCode', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName}`}
                                {...params}
                                error={Boolean(touched.clientCode && errors.clientCode)}
                                variant="outlined"
                                margin="dense"
                                required
                                label="Client Number"
                                placeholder="Select Client Number"
                              />
                            </div>
                          )}
                        />
                        <FormHelperText>
                          {touched.clientCode && errors.clientCode && errors.clientCode}
                        </FormHelperText>
                      </div>
                    )}
                  </div>
                </div>
                <div className="new-standard-textfields d-flex justify-content-center my-2">
                  <Button
                    variant="outlined"
                    onClick={() => {
                      resetForm(initialValues);
                      setErrorMessage(null);
                      setSuccessMessage(null);
                    }}
                    className={`reset-btn mx-1 ${classes.buttonRoot}`}
                  >
                    Reset
                  </Button>
                  {successMessage ||
                  values?.action?.value === 'Bypass' ||
                  values?.action?.value === 'Bypass Record' ||
                  values?.action?.value === 'Error Record' ||
                  values.action?.value === 'Change Client' ||
                  values.action?.value === 'Change Status' ? (
                      <Button
                        type="submit"
                        variant="outlined"
                        className={`search-btn mx-1 ${classes.buttonRoot}`}
                      >
                      Save
                      </Button>
                    ) : (
                      <Tooltip title="Please check syntax before saving">
                        <span>
                          <Button
                            variant="outlined"
                            disabled={true}
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                          >
                          Save
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                </div>
              </div>
            </Form>
            {isLoading && <PageLoader />}
          </>
        );
      }}
    </Formik>
  );
};

export default ActionAddRule;
